<template>
  <div class="export-info">
    <div
      class="export-info-c"
      :style="{width: state === 'upload' ? '368px' : '400px'}"
    >
      <div class="export-info-c-t">
        <h3>批量导入</h3>
        <mk-iconfont
          class="close"
          icon-class="guanbi"
          @click.native="cancel"
        ></mk-iconfont>
      </div>
      <template v-if="state === 'upload'">
        <div class="export-info-content">
          <div class="tit">
            上传附件：
          </div>
          <div class="con">
            <!-- <mk-upload
            accept=".xls,.xlsx"
            :action="fileUpload"
            :file-list="fileList"
          >
            <div class="upload">
              <mk-iconfont
                class="upload-icon"
                icon-class="upload"
              ></mk-iconfont>
              <span class="upload-txt">上传文件</span>
            </div>
          </mk-upload> -->
            <div
              v-if="file !== ''"
              class="show-file"
            >
              <div style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden;">
                <mk-iconfont icon-class="annex"></mk-iconfont>
                <span>{{ file.name }}</span>
              </div>
              <mk-iconfont
                class="clear-icon"
                icon-class="guanbi"
                @click.native="clearIcon"
              ></mk-iconfont>
            </div>
            <div
              v-else
              class="upload"
            >
              <input
                ref="file"
                type="file"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                @change="change"
              />
              <mk-iconfont
                class="upload-icon"
                icon-class="upload"
              ></mk-iconfont>
              <span class="upload-txt">上传文件</span>
            </div>
            <div class="con-info">
              <span>支持扩展名：.xlsx，</span>
              <span>为避免上传失败请下载模板填写</span>
            </div>
            <div
              class="download"
              @click="download"
            >
              下载模板
            </div>
          </div>
        </div>
        <div class="btn-group">
          <mk-button-biz
            width="64px"
            @click="cancel"
          >
            取消
          </mk-button-biz>
          <mk-button-biz
            type="primary"
            width="64px"
            @click="confirm"
          >
            确认
          </mk-button-biz>
        </div>
      </template>
      <template v-if="state === 'uploading'">
        <div class="uploading">
          <div
            v-loading="loading"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
          ></div>
        </div>
        <div class="uploading-txt">
          导入中，请耐心等待
        </div>
        <div class="uploading-progress">
          <mk-progress
            :percentage="percent"
            color="#1890ff"
          />
        </div>
      </template>
      <template v-if="state === 'uploadSuccess'">
        <div class="uploadSuccess">
          <div class="success">
            <mk-iconfont
              class="success-icon"
              icon-class="success"
            ></mk-iconfont>
            <span>导入成功</span>
          </div>
          <div class="uploadSuccess-progress">
            <mk-progress
              :percentage="100"
              color="#52c41a"
            />
          </div>
        </div>
      </template>
      <template v-if="state === 'uploadFail'">
        <div class="uploadFail">
          <div class="fail">
            <mk-iconfont
              class="fail-icon"
              icon-class="guanbihuojingshihuocuowu"
            ></mk-iconfont>
            <span>导入失败</span>
          </div>
          <div class="uploadFail-progress">
            <mk-progress
              :percentage="percent"
              color="#f5222d"
            />
          </div>
          <div class="fail-reason">
            <div class="tit">
              您导入的内容有{{ failInfo.total }}个错误，请修改后重新传：
            </div>
            <ul class="fail-list">
              <li
                v-for="(item,index) in failInfo.list"
                :key="index"
                class="fail-list-item"
              >
                {{ (failInfo.page - 1) * 5 + index + 1 }}.&nbsp;第{{ item.lineNumber }}行，{{ arrayToString(item.messages) }}
              </li>
            </ul>
          </div>
          <div class="fail-handle-page">
            <!-- <div class="total-info">
              共{{ failInfo.total }}条
            </div> -->
            <div class="page-info">
              <mk-pagination
                class="pagination"
                :current-page.sync="failInfo.page"
                :page-size="5"
                layout="total, prev, pager, next, jumper"
                :total="failInfo.total"
                @current-change="handleCurrentChange"
              >
              </mk-pagination>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { BIZAPIS } from '../../../api'
const { VUE_APP_PC_B_BASE_URL } = process.env
export default {
  data () {
    return {
      file: '',
      /**
       * 上传: upload
       * 上传中: uploading
       * 上传成功: uploadSuccess
       * 上传失败: uploadFail
       */
      state: 'upload',
      loading: true,
      failInfo: {
        page: 1,
        total: 0,
        list: [],
        initList: []
      },
      percent: 0,
      timer: ''
    }
  },
  created () {
    this.state = 'upload'
    this.percent = 0
    if (this.timer) {
      clearInterval(this.timer)
    } else {
      this.timer = ''
    }
  },
  methods: {
    arrayToString (arr) {
      if (arr instanceof Array) {
        let str = ''
        arr.forEach((item, index) => {
          if (index === arr.length - 1) {
            str += item
          } else {
            str += item + '，'
          }
        })
        return str
      } else {
        return arr
      }
    },
    showError (errorMsg) {
      this.$message({
        type: 'error',
        message: errorMsg,
        showClose: true
      })
    },
    showSuccess (msg) {
      this.$message({
        type: 'success',
        message: msg,
        showClose: true
      })
    },
    cancel () {
      this.$emit('cancel')
    },
    handleCurrentChange (e) {
      this.failInfo.page = e
      this.failInfo.list = this.failInfo.initList.slice(
        0 + 5 * (e - 1),
        5 + 5 * (e - 1)
      )
    },
    // async confirm () {
    //   if (this.file) {
    //     this.state = 'uploading'
    //     this.handlePercentage()
    //     let formData = new FormData()
    //     formData.append('file', this.file)
    //     const res = await BIZAPIS.SalesApi.yqfSalesManageImportPost({
    //       file: formData
    //     })
    //     if (res) {
    //       clearInterval(this.timer)
    //       if (res.success) {
    //         this.state = 'uploadSuccess'
    //         this.$emit('success')
    //       } else {
    //         // this.$emit('success') // 进度进行成功，需要刷新列表
    //         this.state = 'uploadFail'
    //         this.failInfo.total = res.data.length
    //         this.failInfo.initList = res.data
    //         if (res.data.length > 5) {
    //           this.failInfo.list = this.failInfo.initList.slice(0, 5)
    //         } else {
    //           this.failInfo.list = res.data
    //         }
    //       }
    //     }
    //   } else {
    //     this.$message({
    //       type: 'error',
    //       message: '请上传excel文件',
    //       showClose: true
    //     })
    //   }
    // },
    async confirm () {
      if (this.file) {
        this.state = 'uploading'
        this.handlePercentage()
        let formData = new FormData()
        // formData.append('file', this.file)
        formData.append('file', this.file)
        const res = await BIZAPIS.SalesApi.yqfSalesManageImportPost(formData)
        if (res) {
          clearInterval(this.timer)
          if (res.success) {
            this.state = 'uploadSuccess'
            this.$emit('success')
          } else {
            // this.$emit('success') // 进度进行成功，需要刷新列表
            this.state = 'uploadFail'
            this.failInfo.total = res.data.length
            this.failInfo.initList = res.data
            if (res.data.length > 5) {
              this.failInfo.list = this.failInfo.initList.slice(0, 5)
            } else {
              this.failInfo.list = res.data
            }
          }
        }
      } else {
        this.$message({
          type: 'error',
          message: '请上传excel文件',
          showClose: true
        })
      }
    },
    handlePercentage () {
      this.percent = 0
      this.timer = setInterval(() => {
        this.percent += 1
        if (this.percent === 99) {
          clearInterval(this.timer)
        }
      }, 100)
    },
    change (e) {
      this.file = e.target.files[0]
    },
    clearIcon () {
      this.file = ''
      this.$refs.file.values = ''
    },
    async download () {
      const res = await BIZAPIS.SalesApi.yqfSalesManageDownloadGet({})
      if (res.success) {
        this.util.download({
          href: res.data
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.export-info {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2001;

  .export-info-c {
    width: 368px;
    background: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 4px;

    .export-info-c-t {
      // width: calc(100% - 40px);
      width: 100%;
      height: 54px;
      box-sizing: border-box;
      padding: 0 20px;
      margin: 0 auto;
      display: flex;
      box-shadow: 0 -1px 0 0 rgba(232, 232, 232, 1) inset;
      border-radius: 4px 4px 0 0;
      justify-content: space-between;
      align-items: center;

      h3 {
        font-size: 14px;
      }

      .close {
        cursor: pointer;
        font-size: 14px;
        color: #bfbfbf;
      }
    }
  }

  .export-info-content {
    width: calc(100% - 40px);
    margin: 0 auto;
    display: flex;
    font-size: 13px;
    color: #262626;
    padding: 20px 0 30px 0;

    .tit {
      flex-shrink: 0;
      margin-top: 6px;
    }

    /deep/ .el-upload {
      border: none;
    }

    .show-file {
      width: 260px;
      height: 32px;
      box-sizing: border-box;
      background-color: #f5f5f5;
      font-size: 13px;
      color: #595959;
      line-height: 32px;
      display: flex;
      justify-content: space-between;

      div {
        margin-left: 10px;

        span {
          margin-left: 8px;
        }
      }

      .clear-icon {
        margin-right: 10px;
        font-size: 13px;
        cursor: pointer;
      }
    }

    .upload {
      width: 106px;
      height: 32px;
      box-sizing: border-box;
      border-radius: 4px;
      border: 1px solid #d9d9d9;
      display: flex;
      align-items: center;

      .upload-icon {
        margin-left: 12px;
      }

      .upload-txt {
        font-size: 14px;
        color: #595959;
        margin-left: 4px;
      }

      input {
        display: block;
        width: 106px;
        height: 32px;
        opacity: 0;
        position: absolute;
        cursor: pointer;
      }
    }

    .con-info {
      display: flex;
      flex-direction: column;
      margin-top: 8px;

      span {
        display: block;
        font-size: 13px;
        color: #8c8c8c;
        line-height: 24px;
      }
    }

    .download {
      font-size: 13px;
      color: #009cff;
      cursor: pointer;
      margin-top: 4px;
    }
  }

  .btn-group {
    display: flex;
    justify-content: center;
    // margin-right: 20px;
    margin-bottom: 30px;
  }

  .uploading {
    width: 60px;
    height: 60px;
    margin: 0 auto;
    margin-top: 20px;
    margin-bottom: 20px;

    /deep/ .el-icon-loading {
      font-size: 60px;
      margin-top: 20px;
      color: #1890ff;
    }
  }

  .uploading-txt {
    text-align: center;
    font-size: 13px;
    line-height: 18px;
    color: #262626;
    font-weight: 500;
  }

  .uploading-progress {
    width: calc(100% - 50px);
    margin: 0 auto;
    padding: 28px 0 32px 0;
  }

  .uploadSuccess {
    .success {
      margin: 20px 0 24px 20px;
      height: 24px;
      display: flex;
      justify-items: center;

      .success-icon {
        color: #52c41a;
        font-size: 20px;
      }

      span {
        color: #262626;
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        margin-left: 12px;
      }
    }

    .uploadSuccess-progress {
      width: calc(100% - 50px);
      margin: 0 auto;
      padding-bottom: 32px;
    }
  }

  .uploadFail {
    margin-bottom: 20px;

    .fail {
      margin: 20px 0 24px 20px;
      height: 24px;
      display: flex;
      justify-items: center;

      .fail-icon {
        color: #f5222d;
        font-size: 20px;
      }

      span {
        color: #262626;
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        margin-left: 12px;
      }
    }

    .uploadFail-progress {
      width: calc(100% - 50px);
      margin: 0 auto;
      padding-bottom: 22px;
    }

    .fail-reason {
      width: calc(100% - 50px);
      margin: 0 auto;
      background-color: #f5f5f5;
      padding: 10px;

      .tit {
        font-size: 14px;
        font-weight: 500;
        color: #262626;
        margin-bottom: 10px;
      }

      .fail-list {
        .fail-list-item {
          color: #595959;
          font-size: 14px;
          line-height: 22px;
        }
      }
    }

    .fail-handle-page {
      width: calc(100% - 40px);
      margin: 0 auto;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      background-color: #f5f5f5;
      margin-top: 2px;

      .total-info {
        font-size: 13px;
        color: #6d7278;
        margin-left: 10px;
        flex-shrink: 0;
      }

      .page-info {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        // margin-right: -32px;
        margin: 0 -32px;

        // /deep/ .pagination {
        //   font-size: 13px;
        //   display: flex;
        //   align-items: center;
        //   margin-top: 0;

        //   .btn-prev {
        //     background: none;
        //     width: 0;
        //     height: 0;
        //     border-top: 6px solid transparent;
        //     border-bottom: 6px solid transparent;
        //     border-right: 6px solid #595959;

        //     .el-icon-arrow-left {
        //       display: none;
        //     }
        //   }

        //   .btn-prev:disabled {
        //     border-right: 6px solid #bfbfbf;
        //   }

        //   .btn-next {
        //     background: none;
        //     width: 0;
        //     height: 0;
        //     border-top: 6px solid transparent;
        //     border-bottom: 6px solid transparent;
        //     border-left: 6px solid #595959;

        //     .el-icon-arrow-right {
        //       display: none;
        //     }
        //   }

        //   .btn-next:disabled {
        //     border-left: 6px solid #bfbfbf;
        //   }

        //   .el-pager {
        //     margin: 0 8px;

        //     li {
        //       min-width: 30px;
        //       height: 24px;
        //       line-height: 24px;
        //     }
        //   }
        // }

        .page-tip {
          font-size: 14px;
          color: #595959;
          margin-left: -16px;
        }

        // .jump {
        //   font-size: 13px;
        //   color: #595959;
        //   margin-left: 88px;

        //   input {
        //     width: 58px;
        //     height: 24px;
        //     padding: 0 12px;
        //     box-sizing: border-box;
        //     border: 1px solid #d9d9d9;
        //     border-radius: 2px;
        //   }

        //   input::-webkit-outer-spin-button,
        //   input::-webkit-inner-spin-button {
        //     -webkit-appearance: none;
        //   }

        //   input[type='number'] {
        //     -moz-appearance: textfield;
        //   }
        // }
      }
    }
  }
}
</style>
